<template>
    <el-row class="c_nav_menu_wrapper">
        <el-menu :default-active="getActiveIndex()" class="c_nav_menu" mode="horizontal" router>
            <el-menu-item index="/monitor/index">
                <i class="iconfont iconft-bar-chart" style="margin-right: 0"></i>
            </el-menu-item>
            <el-menu-item index="/order">
                <i class="iconfont iconft-notebook"></i> <span slot="title">管订单</span>
            </el-menu-item>
            <el-menu-item index="/inventory">
                <i class="iconfont iconft-notebook"></i> <span slot="title">管库存</span>
            </el-menu-item>
            <el-menu-item index="/purchase">
                <i class="iconfont iconft-notebook"></i> <span slot="title">管采购</span>
            </el-menu-item>
            <el-menu-item index="/report">
                <i class="iconfont iconft-notebook"></i> <span slot="title">管报表</span>
            </el-menu-item>
            <el-menu-item index="/sale">
                <i class="iconfont iconft-notebook"></i> <span slot="title">管销售</span>
            </el-menu-item>
            <el-menu-item index="/config">
                <i class="el-icon-setting"></i> <span slot="title">设置</span>
            </el-menu-item>
        </el-menu>
    </el-row>
</template>

<script>
export default {
    data :function() {
        return {
            getActiveIndex:function(){
                let path = this.$route.path;
                if(path.startsWith('/order')) return '/order';
                if(path.startsWith('/inventory')) return '/inventory';
                if(path.startsWith('/purchase')) return '/purchase';
                if(path.startsWith('/report')) return '/report';
                if(path.startsWith('/sale')) return '/sale';
                if(path.startsWith('/config')) return '/config';
                return '/monitor/index';
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
<style>
    /*主导航和子导航共用样式*/
    .c_nav_menu_wrapper{
        border: 1px solid #eaeaea;
        border-top: none;
        background: #fff;
    }
    .c_nav_menu{
        margin: 0 auto;
        border: none;
        background: none;
        padding-left: 50px;
    }
    .c_nav_menu .el-menu-item{
        height: 50px;
        line-height: 50px;
        padding-left: 0px;
        padding-right: 0px;
        margin-right: 58px;
    }
    .c_nav_menu .el-menu-item.is-active{
        border-bottom-color: #2377E4;
    }
    .c_nav_menu .el-menu-item:focus,
    .c_nav_menu .el-menu-item:hover{
        background: none;
    }
    /*subnav*/
    .c_subnav .c_nav_menu{ padding-left: 0px }
    .c_subnav .c_nav_menu .el-menu-item{ margin: 0 20px 0 50px }
    .c_subnav .c_nav_menu .el-menu-item.is-active{ border-bottom-color: transparent;color: #2377E4;font-weight: 700 }
</style>



// WEBPACK FOOTER //
// src/components/common-nav.vue